"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueCursor_1 = require("../ui/rogueCursor");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var rogueUiMain_sidecar_1 = require("../ui/rogueUiMain-sidecar");
var rogueGamepad_1 = require("./rogueGamepad");
var rogueInput_1 = require("./rogueInput");
var rogueMouse_sidecar_1 = require("./rogueMouse-sidecar");
var rogueRunMode_sidecar_1 = require("./rogueRunMode-sidecar");
var _lastGridX = 0;
var _lastGridY = 0;
var update = function () {
    var input = rogueMouse_sidecar_1.rogueMouse.getInput();
    var _a = rogueCursor_sidecar_1.rogueCursor.getMouseGridXY(), gridX = _a.gridX, gridY = _a.gridY;
    if (gridX !== _lastGridX || gridY !== _lastGridY) {
        // mouse moved, use it for targeting
        rogueCursor_sidecar_1.rogueCursor.setInputMouse();
        _lastGridX = gridX;
        _lastGridY = gridY;
    }
    // console.log('handler', input.left)
    if (rogueUiMain_sidecar_1.rogueUiMain.isUiOpen()) {
        return;
    }
    if (rogueCursor_sidecar_1.rogueCursor.get().mode !== rogueCursor_1.ERogueTargetMode.none) {
        // No normal movement
        if (input.left === rogueGamepad_1.InputState.JustDown) {
            (0, rogueInput_1.setNextInputCommand)(rogueInput_1.EInputCommand.select);
            // Fire here!
            // rogueCursor.setTargetMode(ERogueTargetMode.none)
        }
        if (input.right === rogueGamepad_1.InputState.JustDown) {
            (0, rogueInput_1.setNextInputCommand)(rogueInput_1.EInputCommand.cancel);
        }
        return;
    }
    if (input.left === rogueGamepad_1.InputState.JustUp) {
        rogueRunMode_sidecar_1.rogueRunMode.cancelRunMode();
    }
    if (input.left === rogueGamepad_1.InputState.JustDown ||
        input.left === rogueGamepad_1.InputState.StaleDown) {
        var mouse = rogueCamera_sidecar_1.rogueCamera.getAdjustedMousePosition();
        var isNew_1 = input.left === rogueGamepad_1.InputState.JustDown;
        var updateMouseMovement = function (c) {
            if (isNew_1) {
                (0, rogueInput_1.setNextInputCommandAndRun)(c);
            }
            else {
                if (c !== rogueInput_1.EInputCommand.moveWait) {
                    rogueRunMode_sidecar_1.rogueRunMode.redirectMouseRunMode(c);
                }
                else {
                    rogueRunMode_sidecar_1.rogueRunMode.redirectMouseRunMode(rogueInput_1.EInputCommand.none); // wait for mouse to move
                }
            }
        };
        var player = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
        if (player) {
            if (rogueDef_sidecar_1.rogueDef.isSameSpot(gridX, gridY, player.x, player.y)) {
                updateMouseMovement(rogueInput_1.EInputCommand.moveWait);
            }
            else {
                var dy = gridY - player.y;
                var dx = gridX - player.x;
                if (Math.abs(dy) > Math.abs(dx)) {
                    if (dy < 0) {
                        updateMouseMovement(rogueInput_1.EInputCommand.moveUp);
                    }
                    else {
                        updateMouseMovement(rogueInput_1.EInputCommand.moveDown);
                    }
                }
                else {
                    if (dx > 0) {
                        updateMouseMovement(rogueInput_1.EInputCommand.moveRight);
                    }
                    else {
                        updateMouseMovement(rogueInput_1.EInputCommand.moveLeft);
                    }
                }
            }
        }
    }
};
exports.update = update;
